module.exports = __webpack_public_path__ + "img/cancel.531602b2.svg";